<template>
  <div>
    <CommonTable
      :list-array="list"
      delete-item-dispatch="projectAccountingStore/costAllocatorStore/delete"
      create-item-dispatch="projectAccountingStore/costAllocatorStore/create"
      update-item-dispatch="projectAccountingStore/costAllocatorStore/update"
      :static-dispatch-params="{
        project_id: this.projectId,
        [`_${this.$props.mode}`]: { id: this.$props.costCentre }
      }"
      :headers="headers"
      :slots="slots"
      :actions="actions"
      resource="cost-allocators"
      :can-delete="canDelete"
      :can-add="canAdd"
      :can-edit="canEdit"
      @updated="updateList"
      :default-limit="-1"
    ></CommonTable>
  </div>
</template>

<script>
import CommonTable from "../../../common/tables/CommonTable";
import { rules } from "../../../mixins/rules";
import { projectPermissions } from "../../../mixins/projects/projectPermissions";

export default {
  name: "ListCostAllocator",
  props: {
    mode: {
      type: String
    },
    costCentre: {
      type: String
    },
    projectId: {
      type: String
    },
    isActiveTab: {
      type: Boolean,
      default: true
    }
  },
  components: {
    CommonTable
  },
  mixins: [rules, projectPermissions],
  data: function() {
    return {
      actions: [],
      list: [],
      page: {},
      isTariffPlanVisible: false
    };
  },
  computed: {
    headers() {
      return [
        this.mode !== "provider"
          ? {
              text: this.$t("cost-allocators.providing-cost-centre"),
              align: "left",
              value: "provider_name"
            }
          : {
              text: this.$t("cost-allocators.consuming-cost-centre"),
              align: "left",
              value: "consumer_name"
            },
        {
          text: this.$t("cost-allocators.ratio"),
          value: "ratio",
          sortable: false
        },
        {
          text: this.$t("cost-allocators.type"),
          value: "type_name"
        },
        {
          text: this.$t("cost-allocators.calculation-base"),
          value: "path",
          sortable: false
        },
        {
          text: this.$t("cost-allocators._tariff_plan_name"),
          value: "_tariff_plan_name",
          align: "left"
        },
        {
          text: this.$t("cost-allocators.compensation-factors"),
          value: "factors",
          sortable: false
        },
        {
          text: this.$t("cost-allocators.action"),
          value: "action",
          align: "right",
          sortable: false
        }
      ];
    },
    slots() {
      let rules = this.rules;
      let costCentres = this.costCentres;
      let types = this.types;
      return [
        {
          name: "provider_name",
          type: "link",
          to: "cost-centre",
          title: "providing-cost-centre",
          linkParams: {
            id: "provider_id"
          },
          form: {
            type: "autocomplete",
            name: "provider_id",
            items: costCentres,
            rules: [rules.required],
            visible: true
          }
        },
        {
          name: "consumer_name",
          type: "link",
          to: "cost-centre",
          title: "consuming-cost-centre",
          linkParams: {
            id: "consumer_id"
          },
          form: {
            type: "autocomplete",
            name: "consumer_id",
            items: costCentres,
            rules: [rules.required],
            visible: true
          }
        },
        {
          name: "ratio",
          form: {
            type: "text",
            rules: [rules.required, rules.number({ min: 0, max: 1 })],
            visible: true
          }
        },
        {
          name: "type_name",
          type: "link",
          to: "cost-allocator",
          title: "type",
          form: {
            type: "select",
            name: "type",
            items: types,
            rules: [rules.required],
            visible: true
          }
        },
        {
          name: "factors",
          title: "compensation-factors",
          form: {
            type: "text",
            visible: true
          }
        },
        {
          name: "path",
          type: "groups",
          divider: " > ",
          form: {
            type: "calculation-base",
            name: "calculation_base",
            rules: [rules.required],
            visible: true
          }
        },
        {
          name: "_tariff_plan_name",
          type: "combobox",
          form: {
            name: "_tariff_plan_id",
            type: "autocomplete",
            items: this.plans,
            rules: this.isTariffPlanVisible ? [rules.required] : [],
            visible: true
          }
        }
      ];
    },
    getParams() {
      return `${this.$route.query.page}
              ${this.$route.query.limit_items}
              ${this.$route.query.orders}
              `;
    },
    costCentres() {
      return this.$store.getters[
        "projectAccountingStore/costCentreStore/getList"
      ].map(i => ({ value: i.id, text: i.name }));
    },
    types() {
      return this.$store.getters[
        "projectAccountingStore/costAllocatorStore/getTypes"
      ];
    },
    plans() {
      const tariffPlanObject = this.$store.getters[
        "projectMeteringStore/tariffPlanStore/getList"
      ];

      if (tariffPlanObject) {
        const tariffPlansArray = Object.values(tariffPlanObject);
        const mappedTariffPlans = tariffPlansArray.map(i => {
          return { text: i.name, value: i.id };
        });
        return mappedTariffPlans;
      } else {
        return [];
      }
    },
    canDelete: {
      get() {
        return this.hasCurrentProjectPermissions("cost_allocator.delete");
      }
    },
    canAdd: {
      get() {
        return this.hasCurrentProjectPermissions("cost_allocator.create");
      }
    },
    canEdit: {
      get() {
        return this.hasCurrentProjectPermissions("cost_allocator.update");
      }
    }
  },
  watch: {
    "list.type_name": function(newVal) {
      this.isTariffPlanVisible = newVal === "unitbased";
    },
    getParams: function() {
      this.updateList();
    },
    costCentre: function() {
      this.updateList();
    }
  },
  methods: {
    updateList() {
      if (!this.isActiveTab) return;
      let params = this.formingParams();
      this.$store.dispatch(
        "projectAccountingStore/costAllocatorStore/getList",
        {
          params,
          onSuccess: () => {
            this.loading = false;
            this.list = this.$store.getters[
              "projectAccountingStore/costAllocatorStore/getList"
            ];
            this.page = this.$store.getters[
              "projectAccountingStore/costAllocatorStore/getPage"
            ];
          }
        }
      );
    },
    formingParams() {
      let orders = (this.$route.query.orders || "")
        .replace("_centre_name", "_centre_id")
        .replace("type_name", "type");
      return {
        project_id: this.$route.params.project_id,
        limit: -1,
        orders,
        filters: {
          [`${this.$props.mode}`]: this.$props.costCentre
        }
      };
    }
  },
  mounted() {
    this.updateList();
    this.$store.dispatch("projectMeteringStore/groupStore/getList", {
      params: {
        limit: -1,
        project_id: this.$route.params.project_id
      }
    });
    this.$store.dispatch("projectAccountingStore/costCentreStore/getList", {
      params: {
        limit: -1,
        project_id: this.$route.params.project_id
      }
    });
    this.$store.dispatch("projectMeteringStore/meterUnitStore/getList", {
      params: {
        limit: -1,
        project_id: this.$route.params.project_id
      }
    });
    this.$store.dispatch("projectMeteringStore/tariffPlanStore/getList", {
      params: { limit: -1, project_id: this.$route.params.project_id }
    });
  }
};
</script>

<style scoped></style>
